const addToCartListener = () => {
    const removeProductFromCartElements = [
        ...document.querySelectorAll('.js-add-product-to-cart-datalayer'),
    ].filter((el) => !el.dataset.removeProductFromCartInitialized);

    removeProductFromCartElements.forEach((el) => {
        el.addEventListener('click', () => {
            const productData = el.getAttribute('datalayer');

            window.dispatchEvent(
                new CustomEvent('datalayer.add_to_cart_upsell', {
                    detail: { productData },
                })
            );
        });

        el.dataset.removeProductFromCartInitialized = true;
    });
};

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        addToCartListener();
    });
});
